import { FaWhatsapp } from "react-icons/fa";
import { useSettingsFetch } from "../../hooks/useFetchSettingsData";

const FloatingWhatsApp = () => {
  const { data: whatsapp_number } = useSettingsFetch("whatsapp_number");

  return (
    <div className="fixed bottom-8 right-6 z-[9999]">
      {/* Ping effect */}
      <span className="absolute inline-flex w-12 h-12 bg-green-400 rounded-full opacity-75 animate-ping"></span>
      <span className="absolute inline-flex w-12 h-12 delay-200 bg-green-400 rounded-full opacity-50 animate-ping"></span>

      {/* WhatsApp button */}
      <a
        href={`https://wa.me/${whatsapp_number?.value}`}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center w-12 h-12 transition-transform bg-green-500 rounded-full shadow-lg hover:scale-110"
      >
        <FaWhatsapp className="text-3xl text-white" />
      </a>
    </div>
  );
};

export default FloatingWhatsApp;
